<template>
<!-- eslint-disable -->
  <div class="limiter">
    <v-app id="inspire">
      <div class="container-login100">
        <div
          class="content-overlay"
          :style="cssProps"
        />
            <div class="wrap-login100">
              <div class="login-main-body-wrap">
                    <div class="login-body-wrap">
                        <div class="login-body-container">
                          <div class="login100-pic js-tilt">
                            <div class="login-logo-wrap">
                                <img
                                  class="main-logo"
                                  src="@/assets/images/nic-asia-bank-2.png"
                                  alt="IMG"
                                >
                            </div>
                          </div>

                          <div class="login100-form validate-form">                        
                              <router-view/>
                          </div>
                        </div>
                    </div>
                    <div class="login-main-banner">
                      <img src="@/assets/images/paylink.jpg" alt="">
                    </div>
              </div>
            </div>
      </div>
    </v-app>
  </div>
</template>

<script>

import '@/assets/sass/pages/login.scss';
export default {
    name: 'Index',

    data () {
        return {
            isSignUp: false,
            cssProps: {
                backgroundImage: `url(${require('@/assets/images/hero_area_bg1.jpg')})`,
            },
            headerTitle: 'Login'
        }
    },
    methods: {
       
    }
}
</script>


